import { FC, Suspense } from 'react';
import LoadMore from '~/components/load-more';
import { Masonry } from '~/components/masonry';
import { useAtomValue } from 'jotai';
import { $CurrentUserPost } from '@user/shared/current-user-post';
import { ArticleRecommendCard } from '~/components/article-recommend-card';
import { EClickPosition } from 'shared/constant';
import { EmptyTab } from '../../components/empty-tab';
import { Loading } from '~/components/loading';
import { RelatedUserCard } from '../../components/related-user-card';
import { $Locale } from '@lemon8/web-app-shared/atom';
import { Region } from '@lemon8/web-app-shared/i18n';
import { $CurrentUserRelatedUser } from '@user/shared/current-user-related-user';
import { useTranslation } from 'react-i18next';
import ChevronRightIcon from 'icon/chevron_right.svg';
import { Loaders } from 'shared/constant/loaders';
import { useRouteLoader } from '@lemon8/web-app-shared/ssr';
import { $UserPostLoadmore, $UserRelatedUserLoadmore } from 'shared/atoms';
import { $CurrentUserAsAvailable } from '@user/shared/current-user';

import './style.scss';
import { EPageModule } from 'shared/constant/page-module';

const UserPostSection: FC = () => {
  const { items: userPostItems, hasMore: userPostHasMore, maxBeHotTime } = useAtomValue($CurrentUserPost);

  const loader = useRouteLoader(
    Loaders.User.UserPostsLoadmore,
    {
      max_behot_time: maxBeHotTime,
    },
    {
      atomFamilies: {
        $UserPostLoadmore,
      },
    },
  );

  const loadData = () => {
    loader.load();
    return Promise.resolve({ data: [] });
  };

  if (!userPostHasMore && userPostItems.length === 0) {
    return <EmptyTab tab="posts" variant="empty" />;
  }

  return (
    <LoadMore
      loadData={loadData}
      isEnd={!userPostHasMore}
      showEnd={false}
      render={() => (
        <>
          <Masonry className="user-collection-masonry" columnCount={2}>
            {userPostItems.map((item, index) => (
              <ArticleRecommendCard
                key={item.groupId}
                pageModule={EPageModule.AuthorPost}
                clickPosition={EClickPosition.AuthorPost}
                article={item}
                rank={index}
              />
            ))}
          </Masonry>
          {userPostHasMore && (
            <div className="user-collection-post-loading">
              <Loading variant={'ball'} fitParent />
            </div>
          )}
        </>
      )}
    />
  );
};

const UserRelatedUserSection: FC = () => {
  const { t } = useTranslation();
  const user = useAtomValue($CurrentUserAsAvailable);
  const { hasMore: userPostHasMore } = useAtomValue($CurrentUserPost);
  const { items: relatedUserItems, hasMore: relatedUserHasMore, sessionImprId } = useAtomValue($CurrentUserRelatedUser);
  const { region } = useAtomValue($Locale);

  const loader = useRouteLoader(
    Loaders.User.UserRelatedUserLoadmore,
    {
      media_id: user.userId,
      session_impr_id: sessionImprId,
    },
    {
      atomFamilies: {
        $UserRelatedUserLoadmore,
      },
    },
  );

  const loadData = (): Promise<{ data: [] }> => {
    loader.load();
    return Promise.resolve({ data: [] });
  };

  if (![Region.jp].includes(region) || userPostHasMore || !relatedUserItems.length) {
    return null;
  }

  return (
    <div className="user-collection-related_user">
      <LoadMore
        loadData={loadData}
        isEnd={!relatedUserHasMore}
        showEnd={false}
        render={() => (
          <>
            <div className="user-collection-related_user-head">
              <h2>{t('shareWeb_creatorsRecommendation_btn')}</h2>
              <p>
                {t('sharing_recommend_title')}
                <ChevronRightIcon />
              </p>
            </div>
            {relatedUserItems.map((user) => (
              <RelatedUserCard key={user.userId} user={user} />
            ))}
            {relatedUserHasMore && (
              <div className="user-collection-post-loading">
                <Loading variant={'ball'} fitParent />
              </div>
            )}
          </>
        )}
      />
    </div>
  );
};

export const TabCollection: FC = () => {
  return (
    <div className="user-content-section collection">
      <Suspense>
        <UserPostSection />
        {/* <Suspense>
          <UserRelatedUserSection />
        </Suspense> */}
      </Suspense>
      <footer />
    </div>
  );
};
